<template>
    <div>
        <div>
            <el-button type="text" @click="doCopy"><i class="material-icons">content_copy</i> {{trackingURL}}</el-button>
        </div>
        <el-row :gutter="20" class="track-suback">
            <el-col :span="6">
                <label>
                    Source
                </label>
                <el-input v-model="subs.source"></el-input>
            </el-col>
            <el-col :span="6">
                <label>Sub1</label>
                <el-input v-model="subs.sub1"></el-input>
            </el-col>
            <el-col :span="6">
                <label>Sub2</label>
                <el-input v-model="subs.sub2"></el-input>
            </el-col>
            <el-col :span="6">
                <label>Sub3</label>
                <el-input v-model="subs.sub3"></el-input>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="track-suback">
            <el-col :span="6">
                <label>Sub4</label>
                <el-input v-model="subs.sub4"></el-input>
            </el-col>

            <el-col :span="6">
                <label>Sub5</label>
                <el-input v-model="subs.sub5"></el-input>
            </el-col>

            <el-col :span="6">
                <label>Click Id</label>
                <el-input v-model="subs.click_id"></el-input>
            </el-col>

        </el-row>

        <div style="margin-top: 15px;">
            <el-button type="primary" @click="save" :loading="loading_form">{{ $t('save_macros') }}</el-button>
        </div>

    </div>
</template>

<script>
    import qs from 'qs';
    export default {
        name: "StreamLink",
        props: {
            item: [Object]
        },
        data () {
            return {
                subs: {},
                loading_form: false
            }
        },
        created () {
            this.subs = qs.parse(this.item.macros);
        },
        watch:{
            'item'(){
                this.subs = qs.parse(this.item.macros);
            },
        },
        computed: {
            trackingURL() {

                let searchParams = new URLSearchParams();

                if (!this.subs.source) {
                    delete this.subs.source;
                }

                if (!this.subs.sub1) {
                    delete this.subs.sub1;
                }

                if (!this.subs.sub2) {
                    delete this.subs.sub2;
                }

                if (!this.subs.sub3) {
                    delete this.subs.sub3;
                }

                if (!this.subs.sub4) {
                    delete this.subs.sub4;
                }

                if (!this.subs.sub5) {
                    delete this.subs.sub5;
                }

                if (!this.subs.click_id) {
                    delete this.subs.click_id;
                }

                let query = '';

                if (searchParams.toString()) {
                    query = '?' + decodeURI(searchParams.toString());
                }

                if (Object.keys(this.subs).length !== 0) {
                    query = '?' + decodeURI(qs.stringify(this.subs));
                }

                return this.item.tracking_link + query;
            }
        },
        methods: {
            save () {
                this.loading_form=true;
                this.$axios.patch('/streams/' + this.item.id + '?expand=landings,offer', {macros: decodeURI(qs.stringify(this.subs))}).then((res) => {
                    this.loading_form=false;
                    this.$message.success(this.$t('notice.saved'));
                    this.$emit('update', res.data);
                });
            },
            doCopy: function () {
                const vm = this;
                this.$copyText(this.trackingURL).then(function () {
                    vm.$message.success(vm.$t('notice.link_copied'));
                })
            }
        }
    }
</script>

<style scoped lang="scss">
.track-link {
  color: #117BFD;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 25px;
  cursor: pointer;
}
.track-suback {
  margin-top: 15px;
  label {
    float: left;
    margin-bottom: 5px;
    color: #6F7990;
  }
}
</style>
